import CharacterClass from './CharacterClass'

export const armorTypes: { [key: string]: CharacterClass[] } = {
  Cloth: ['Mage', 'Priest', 'Warlock'],
  Leather: ['Demon Hunter', 'Druid', 'Monk', 'Rogue'],
  Mail: ['Evoker', 'Hunter', 'Shaman'],
  Plate: ['Death Knight', 'Paladin', 'Warrior'],
}

export const armorTypeIcons: Record<string, string> = {
  Cloth: 'inv_chest_cloth_21',
  Leather: 'inv_chest_leather_09',
  Mail: 'inv_chest_chain',
  Plate: 'inv_chest_plate05',
}
